import { type CSSProperties } from 'react';

import { COLOR_RED, FONT_INTER, PAGE_BODY_PADDING } from '../shared/blueprint-view-styles';

export const OVERVIEW_BASE_FONT_PX = 14;

// Floor for the shrink-to-fit pass — below this the sheet stops being readable in print.
export const OVERVIEW_MIN_FONT_PX = 9;

export const OVERVIEW_BODY_STYLE: CSSProperties = {
	flex: 1,
	padding: PAGE_BODY_PADDING,
	overflow: 'hidden',
	fontFamily: FONT_INTER,
	fontSize: `${OVERVIEW_BASE_FONT_PX}px`,
	fontWeight: 400,
	lineHeight: '1.4'
};

export const OVERVIEW_BOLD_STYLE: CSSProperties = { fontWeight: 700 };

export const OVERVIEW_RED_STYLE: CSSProperties = {
	color: COLOR_RED,
	fontWeight: 700
};

// Red without bold — matches the reference PDF's normal-weight countertop material text.
export const OVERVIEW_RED_NOTE_STYLE: CSSProperties = { color: COLOR_RED };

export const OVERVIEW_SECTION_SMALL_STYLE: CSSProperties = { marginBottom: '14px' };

export const OVERVIEW_SECTION_XSMALL_STYLE: CSSProperties = { marginBottom: '7px' };

export const OVERVIEW_INDENTED_STYLE: CSSProperties = { marginLeft: '55px' };

export const OVERVIEW_PLEASE_NOTE_WRAPPER_STYLE: CSSProperties = { marginTop: '7px' };

export const OVERVIEW_PLEASE_NOTE_STYLE: CSSProperties = {
	color: COLOR_RED,
	fontWeight: 700,
	marginBottom: '7px'
};

export const OVERVIEW_INDENTED_RED_STYLE: CSSProperties = {
	marginLeft: '55px',
	color: COLOR_RED,
	fontWeight: 700
};
